import { useSnackbar } from 'notistack';
import { useState } from 'react';
// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
// hooks
import useAuth from '../../../hooks/useAuth';
import useResponsive from '../../../hooks/useResponsive';
// axios
import axios from '../../../utils/axios';
import DIOText from '../../../components/DIOText';

// ------------------------------------------------------------

export default function ResumeDialog({ isOpen, closeDialog, jobPostId, reloadJobs=null }) {
  const smUp = useResponsive('up', 'sm');
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  const resumeJobPost = async () => {
    try {
      setIsLoading(true);
      await axios.post(`api/company/${user?.employee.company[0].id}/job-posts/${jobPostId}/resume/`);
      enqueueSnackbar('활성화 되었습니다');
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      enqueueSnackbar('활성화 중 오류가 발생하였습니다. 관리자에게 문의해주세요', { variant: 'error' });
    }
  }

  const cancel = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    closeDialog();
  };

  const resume = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    await resumeJobPost();
    if (reloadJobs) {
      await reloadJobs(jobPostId);
    }
    closeDialog();
  };

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="dg">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant="h5" gutterBottom>
          공고의 매칭을 재개하면, 기존에 매칭되었던 크루는 사라지고 새로운 크루로 매칭됩니다.
        </Typography>
        <Typography>
          기존에 매칭된 크루와 다시 매칭받고 싶으시다면, <DIOText /> 카카오톡 채널에 말씀해 주세요. 
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 }, pt: "0!important" }}>
        <Stack direction={smUp ? "row" : "column-reverse"} spacing={2} sx={{ width: 1 }} justifyContent="flex-end">
          <LoadingButton
            size="large"
            loading={isLoading}
            onClick={cancel}
            sx={{ px: 4 }}
          >
            취소
          </LoadingButton>
          <LoadingButton
            size="large"
            loading={isLoading}
            variant="contained"
            onClick={resume}
          >
            매칭 시작하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
